import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'zone'})
export class TimezonePipe implements PipeTransform {
  transform(zone: string) {
    if (this.isDstObserved()) {
      switch (zone) {
        case 'GMT-4':
          return 'ET';
        case 'GMT-5':
          return 'CT';
        case 'GMT-6':
          return 'PT';
        case 'GMT-7':
          return 'PT'; // do not yet why
        default:
          return zone;
      }
    } else {
      switch (zone) {
        case 'GMT-5':
          return 'ET';
        case 'GMT-6':
          return 'CT';
        case 'GMT-7':
          return 'PT';
        default:
          return zone;
      }
    }
  }

  private isDstObserved(): boolean {
    const today = new Date();
    const jan = new Date(today.getFullYear(), 0, 1);
    const jul = new Date(today.getFullYear(), 6, 1);
    return today.getTimezoneOffset() < Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
  }

}
